// 1. Create an invisible iframe to bypass the theme's silencer
const iframe = document.createElement('iframe');
iframe.style.display = 'none';
document.body.appendChild(iframe);

// 2. Steal its untouched console.log and warn functions
const realLog = iframe.contentWindow.console.log;
const realWarn = iframe.contentWindow.console.warn;

window.gbEvents = window.gbEvents || [];

function testCode() {
	(function () {
		function init() {
			document
				.querySelector(`.product-form`)
				.insertAdjacentHTML(
					'afterend',
					`<img class="hsa-eligible-badge" src="https://cdn.shopify.com/s/files/1/0051/8776/4293/files/HSA_Badge.png?v=1786476411" alt="HSA/FSA eligible. Check out with your HSA or FSA card and pay for cleaner air with pre-tax dollars.">`,
				);
			const style = document.createElement('style');
			style.innerHTML = `
.hsa-eligible-badge {
	width: 80%;
    display: block !important;

    }
    	@media (max-width: 1000px) {
        .hsa-eligible-badge {

	        margin-left: 10% !important;
	        margin-right: 10% !important;
        }
        
        }

  `;
			document.head.appendChild(style);
		}

		console.log('%cAD-10 | HSA on PDPs', "color: white; background-color:#202621; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;");

		function poll(sel, cb) {
			setTimeout(function () {
				if (document.querySelector(sel)) cb();
				else poll(sel, cb);
			}, 50);
		}

		poll('.product-form', init);
	})();
}

// --->  MANUAL A/B TEST RANDOMIZER <---
(function () {
	const preview = true;

	// =========================================================================
	// ---> TEST TARGETING CONFIGURATION
	// =========================================================================
	const config = {
		// URL Filtering
		filterByUrls: true,
		allowedUrls: [
			'airdog-x5-home-air-purifier-1600-sq-ft',
			'airdog-x8-home-air-purifier-1000-sq-ft',
			'airdog-x3-home-air-purifier-215-sq-ft',
			'x1-air-purifier',
		], // Only fires if current URL contains one of these strings

		// Device Filtering
		allowMobile: true,
		allowDesktop: true,
	};

	// Helper: Check if current URL is allowed
	function isUrlAllowed() {
		if (!config.filterByUrls) return true;
		// Using .includes() ensures query parameters won't break the match
		return config.allowedUrls.some((url) => window.location.href.includes(url));
	}

	function isDeviceAllowed() {
		const mobileBreakpoint = 768;
		const isMobile = window.innerWidth < mobileBreakpoint;

		if (isMobile && !config.allowMobile) return false;
		if (!isMobile && !config.allowDesktop) return false;

		return true;
	}

	// Evaluate targeting before running test or preview logic
	if (!isUrlAllowed() || !isDeviceAllowed()) {
		realLog('Test skipped: Does not meet URL or Device targeting rules.');
		return; // Exit out of the A/B test wrapper entirely
	}
	// =========================================================================

	if (!preview) {
		//CHANGE PER TEST: APPEARS AS TEST NAME IN GA4
		const cookieName = 'ab_test_variant';

		// Helper to read cookies
		function getCookie(name) {
			const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
			return match ? match[2] : null;
		}

		// Check if user already has a variant cookie
		let variant = getCookie(cookieName);

		// If they are new, flip a coin (50/50 split) and assign them
		if (!variant) {
			variant = Math.random() < 0.5 ? 'control' : 'v1';

			// Write cookie so variant follows them everywhere (expires in 30 days)
			const date = new Date();
			date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
			document.cookie = cookieName + '=' + variant + ';expires=' + date.toUTCString() + ';path=/';
		}

		// =========================================================================
		// ---> SEND DIRECTLY TO GA4
		// =========================================================================
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}

		gtag('set', 'user_properties', {
			ab_test_variant: variant,
		});

		gtag('event', 'experiment_impression', {
			send_to: 'G-Y4VGNLBJPF',
			debug_mode: true,
		});
		// =========================================================================

		// Run the visual changes
		if (variant === 'v1') {
			realLog('MANUAL TEST: Variation active');
			testCode();
		} else {
			realLog('MANUAL TEST: Control active');
		}

		// Send the page view goal (if you still have a separate tracker looking for gbEvents)
		window.gbEvents.push('Page View');

		if (document.readyState === 'complete') {
			initQuickCheckoutTracking();
		} else {
			window.addEventListener('load', initQuickCheckoutTracking);
		}
	} else if (window.location.href.includes('ad-10')) {
		realLog('%cPreview mode ACTIVE', "color: #F7F631; background-color:black; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;");
		testCode();
	}
})();
